import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { AppConfig } from '../../app.config';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { VitalComparisonReport } from '../models/reports';
import { HttpResponse } from '@angular/common/http';

@Injectable()
export class ReportsService {

    constructor(private http: Http, private config: AppConfig) { }

    getVitalComparisonReport(): Observable<VitalComparisonReport[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/reports/vitalscomparison', { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <VitalComparisonReport[]>response.json();
            }),catchError(this.handleError))
    }

    getVitalComparisonReportPdf():any {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();
        
        headers.append('Authorization', 'Bearer ' + authToken);
        const options = new RequestOptions({
            headers: headers,
            responseType: ResponseContentType.Blob
        });

        return this.http.get(this.config.apiUrl + '/api/reports/vitalscomparisonpdf', options)
            .pipe(map((response: Response) => {
                //console.log(response);
                return response;
            }),catchError(this.handleError))
    }

    // private helper methods
    private handleError(error: Response) {
        return Observable.throw(error.statusText);
    }

    private jwt() {
        // create authorization header with jwt token
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
            return new RequestOptions({ headers: headers });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/reports.service.ts